module.exports = __webpack_public_path__ + "static/media/MugJohn.c8975bef.png";